export class DeviceUtils {

    public static isMobileDevice(): boolean {
        if (typeof navigator === 'undefined') {
            return false;
        }
        const ua: string = navigator.userAgent || '';
        if (/Mobi|Android|iPhone|iPad|iPod|Windows Phone|IEMobile|Opera Mini|BlackBerry|Silk/i.test(ua)) {
            return true;
        }
        return /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1;
    }

}
